import { createTheme } from '@mui/material';
import { palette } from './palette';
import { typography } from './typography';
import { scroll } from './scroll';
import breakpoints from './breakpoints';

const theme = createTheme({
  spacing: 4,
  shape: {
    borderRadius: 4,
  },
  palette,
  typography,
  breakpoints,
  components: {

    MuiSnackbar: {
      styleOverrides: {
        root: ({ theme }) => ({
          right: `${theme.spacing(10)} !important`,
          bottom: `${theme.spacing(10)} !important`,
          left: 'auto !important',
          ' .MiuAlert-icon, .MuiAlert-action': {
            display: 'none',
          },
          ' .MiuAlert-message ': {
            padding: 'unset',
          },

          '& .MuiPaper-root': {
            overflow: 'hidden',
            padding: 'unset',
            borderRadius: theme.spacing(8),
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            backgroundColor: 'black !important',
            // width: '300px',
            maxWidth: theme.spacing(78),

            '& .MuiSnackbarContent-message': {
              padding: 'unset',
              width: '100%',
            },

            '& .MuiAlert-icon, .MuiAlert-action, .MuiSnackbarContent-action': { display: 'none' },
            '& .MuiAlert-message': { padding: 'unset', width: '100%' },
          },
          '& .MuiPaper-root.MuiAlert-standardError': {
            border: `1px solid`,
            '& .NotifyLinearProgress': {
              '& .MuiLinearProgress-bar1': {},
            },
          },
        }),
      },
    },


    MuiCssBaseline: {
      styleOverrides: `
        html, body {
          backgroundColor: '#F5F5F5',
        }
        ${scroll} 
      `,
    },
    MuiAvatar: {
      defaultProps: {
        variant: 'square',
      },
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.white_100,
          width: 112,
          height: 112,
          transform: 'translateZ(0)',
          willChange: 'transform',
          overflow: 'hidden',
        }),
        img: {
          objectFit: 'contain',
        },
      },
    },

  },
});

export default theme;